import { IDLE } from '@/shared/constants/loadingStatuses.constants';

export default {
    profile: {
        username: null,
        firstName: null,
        lastName: null,
        error: null,
        loadingStatus: IDLE,
        mfaAppAuth: null,
        mfaEmail: null,
        mfaInvited: null,
        mfaStatus: IDLE,
        mfaSms: null,
        savedBrowsers: [],
        isMigratedToThryv: false,
        hasGoogleAccount: false,
    },
};
